/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_N1Inputs */

const en_minifier_ref_n1 = /** @type {(inputs: Minifier_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pretty printed baseline with two space indentation.`)
};

const ko_minifier_ref_n1 = /** @type {(inputs: Minifier_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2칸 들여쓰기로 정렬한 기준값입니다.`)
};

const ja_minifier_ref_n1 = /** @type {(inputs: Minifier_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 スペースインデントで整形した基準値です。`)
};

/**
* | output |
* | --- |
* | "Pretty printed baseline with two space indentation." |
*
* @param {Minifier_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_n1 = /** @type {((inputs?: Minifier_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_n1(inputs)
	if (locale === "ko") return ko_minifier_ref_n1(inputs)
	return ja_minifier_ref_n1(inputs)
});